import VueI18n from 'vue-i18n'
import ru from './ru'
import en from './en'
import Vue from 'vue'

Vue.use(VueI18n);

export default new VueI18n({
    locale: localStorage.getItem('lang') || 'ru',
    messages: {
        en,
        ru
    }
});
